import * as yup from 'yup';
import { useI18n } from 'vue-i18n';

export function getRules() {
   const { t } = useI18n();

   return yup.object({
      journey_team_id: yup.string().when('show_spontaneous_application', {
         is: true,
         then: (schema) => schema.required(t('Select a team')),
         otherwise: (schema) => schema.nullable(),
      }),
      journey_id: yup.string().when('show_spontaneous_application', {
         is: true,
         then: (schema) => schema.required(t('Select a journey')),
         otherwise: (schema) => schema.nullable(),
      }),
   });
}
